import { Dayjs } from 'dayjs';

import { CommunityContract } from './contracts';

export type FeeDataType = {
  id?: number;
  key: string;
  living_type_id: number;
  living_type: string;
  pricing_type_id: number;
  pricing_type: string;
  fee_type: FeeType;
  fee_note: string;
  average_cost: number;
  level_1: number;
  level_2: number;
  level_3: number;
  level_4: number;
  level_5: number;
  level_6: number;
  level_7: number;
  level_8: number;
  created_by: string;
  created_at: Date | Dayjs;
  updated_by: string;
  updated_at: Date | Dayjs;
  date: Date | Dayjs;
  contracts: CommunityContract[];
};

export type FeesDataType = {
  id: number;
  type: string;
};

export enum FeeType {
  CARE_FEE = 1,
  MEDICATION_FEE = 2,
}
